/*
 * Judge.me links every review to the product it was written about. The store's
 * reviews were imported from the pre-2026 catalogue, so those products no longer
 * exist and the widget emits a literal href="null" — a relative link that
 * resolves to /null and returns 404. Nineteen of them sit on the home page, and
 * because the links are injected by JavaScript, Googlebot renders the page and
 * follows them.
 *
 * This used to live inside sections/judgeme-reviews.liquid, but the Judge.me app
 * removed that section from templates/index.json on 2026-07-31 while managing its
 * own widgets, and the guard went with it. The reviews themselves are still on the
 * page — they come from the app's own testimonials-carousel block — so the guard
 * belongs somewhere the app cannot reach. Loading it from the layout means it
 * survives whatever any app does to the templates.
 *
 * The anchor is replaced with a span rather than just having its href stripped.
 * An <a> with no href is still an anchor to a search engine, and the audit flags
 * it as an uncrawlable link; a span is simply text, which is what a review whose
 * product no longer exists should be. The visible wording is copied across
 * untouched, so the widget reads exactly the same.
 */
(function () {
  var SELECTOR = 'a[href="null"], a[href="undefined"], a[href="/null"], a[href="/undefined"]';

  function replaceWithSpan(anchor) {
    var span = document.createElement('span');
    span.className = anchor.className ? anchor.className + ' fotw-dead-link' : 'fotw-dead-link';
    span.innerHTML = anchor.innerHTML;
    if (anchor.title) span.title = anchor.title;
    anchor.parentNode.replaceChild(span, anchor);
  }

  function sweep() {
    var dead = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < dead.length; i++) {
      try {
        replaceWithSpan(dead[i]);
      } catch (e) {
        // If anything about the widget's markup is unexpected, fall back to
        // simply disarming the link rather than leaving a live 404 behind.
        dead[i].removeAttribute('href');
      }
    }
    return dead.length;
  }

  function start() {
    sweep();
    if (window.MutationObserver) {
      // The widgets draw late and redraw on paging, so keep watching rather than
      // sweeping once. Replacing a node is itself a mutation, but the replacement
      // is a span and no longer matches the selector, so this cannot loop.
      new MutationObserver(sweep).observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
    window.addEventListener('load', sweep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
